import { useQuery } from '@tanstack/react-query';

import { getMailchimpSyncHealth } from '../api/syncHealth';
import type { MailchimpSyncHealthResponse } from '../types';

export function useMailchimpSyncHealth(orgId: number | string | undefined) {
  return useQuery<MailchimpSyncHealthResponse>({
    queryKey: ['mailchimpSyncHealth', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getMailchimpSyncHealth(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => (query.state.data?.connected ? 30000 : false),
  });
}
